/**
 * Indicates that the local connection statistics were updated.
 */
export const LOCAL_STATS_UPDATED = 'cq.local_stats_updated';

/**
 * Indicates that the connection statistics for a particular remote participant
 * were updated.
 */
export const REMOTE_STATS_UPDATED = 'cq.remote_stats_updated';
